import React from 'react';
import { LinkButton } from '@/components/ui/Buttons';
import Modal from '@/components/ui/Modal';

interface ImpersonateConfirmationModalProps {
  headerText: string;
  href: string;
  isOpen: boolean;
  name: string;
  onClose: () => void;
}

const ImpersonateConfirmationModal = ({
  headerText, href, isOpen, name, onClose,
}: ImpersonateConfirmationModalProps) => (
  <Modal
    close={onClose}
    headerText={headerText}
    isOpen={isOpen}
  >
    <p>By signing in as {name}, you are accessing their account and will see everything they see.</p>
    <br />
    <p>
      <i aria-hidden="true" className="fa fa-exclamation-triangle tw-mr-1 tw-text-yellow" />
      <strong>WARNING:</strong>
    </p>
    <br />
    <p>Any changes made while signed in as {name} will <strong>overwrite</strong> existing data.</p>
    <hr />
    <footer>
      <LinkButton onClick={onClose}>
        Cancel
      </LinkButton>
      <a className="btn btn--purple" href={href}>
        Sign in
      </a>
    </footer>
  </Modal>
);

export default ImpersonateConfirmationModal;
